// Music Lab specific validations.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import ConditionsChecker from './ConditionsChecker';
import { Validator } from './ProgressManager';
var KnownConditions = {
    PLAYED_ONE_SOUND: 'played_one_sound',
    PLAYED_TWO_SOUNDS_TOGETHER: 'played_two_sounds_together',
    PLAYED_THREE_SOUNDS_TOGETHER: 'played_three_sounds_together',
};
var MusicValidator = /** @class */ (function (_super) {
    __extends(MusicValidator, _super);
    function MusicValidator(getIsPlaying, getPlaybackEvents, player, conditionsChecker) {
        if (conditionsChecker === void 0) { conditionsChecker = new ConditionsChecker(KnownConditions); }
        var _this = _super.call(this) || this;
        _this.getIsPlaying = getIsPlaying;
        _this.getPlaybackEvents = getPlaybackEvents;
        _this.player = player;
        _this.conditionsChecker = conditionsChecker;
        return _this;
    }
    MusicValidator.prototype.shouldCheckConditions = function () {
        return this.getIsPlaying();
    };
    MusicValidator.prototype.checkConditions = function () {
        if (this.getPlaybackEvents().length > 0) {
            this.conditionsChecker.addSatisfiedCondition(KnownConditions.PLAYED_ONE_SOUND);
        }
        // Get number of sounds currently playing simultaneously.
        var currentNumberSounds = 0;
        var currentPlayheadPosition = this.player.getCurrentPlayheadPosition();
        this.getPlaybackEvents().forEach(function (eventData) {
            var length = eventData.length;
            if (eventData.when <= currentPlayheadPosition &&
                eventData.when + length > currentPlayheadPosition) {
                currentNumberSounds++;
            }
        });
        if (currentNumberSounds === 3) {
            this.conditionsChecker.addSatisfiedCondition(KnownConditions.PLAYED_THREE_SOUNDS_TOGETHER);
        }
        if (currentNumberSounds === 2) {
            this.conditionsChecker.addSatisfiedCondition(KnownConditions.PLAYED_TWO_SOUNDS_TOGETHER);
        }
    };
    MusicValidator.prototype.conditionsMet = function (conditions) {
        return this.conditionsChecker.checkRequirementConditions(conditions);
    };
    MusicValidator.prototype.clear = function () {
        this.conditionsChecker.clear();
    };
    return MusicValidator;
}(Validator));
export default MusicValidator;
